






import Vue from 'vue'
import CreateForm from '@/components/Newsletters-stuff/CreateForm/CreateForm.vue'
export default Vue.extend({
  components: {
    CreateForm
  }
})
